import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-consult-maladie-pro',
  templateUrl: './consult-maladie-pro.component.html',
  styleUrls: ['./consult-maladie-pro.component.scss']
})

export class ConsultMaladieProComponent implements OnInit {
  ListeMaladies
  dateDeb
  dateFin
  dateDebD
  dateFinF
  constructor(private generalService: GeneralService, private datePipe: DatePipe) {
    this.generalService.getDS('avtPerso','0172').subscribe(res=>{
      console.log(res);
      
    })
    this.generalService.getDS('SOC',1).subscribe(res=>{
      console.log(res);
      
    })
   }

  ngOnInit(): void {
  }
  validDate() {
    let test = true
    if (!this.dateFin && !this.dateDebD) {
      test = false
    }
    return test
  }
  rowClick(event)
  {
    console.log(event);
  }
  filtrer() {
    if (this.validDate()) {
      this.generalService.rechercheTable2('API_ListeMaladies', this.dateDebD + ',' + this.dateFinF).subscribe(res => {
        console.log(res);
        this.ListeMaladies = res
        this.ListeMaladies.forEach(element => {
          this.getVictimeName(element.Perso_Id).then(res=>{
            element.Perso_Name=res
          })
          this.getEmployeurName(element.Employeur_Id).then(res=>{
            element.Employeur_Name=res
          })
        });
      })
    }
    else {
      this.generalService.dialogSuccess(
        'Choisir les date',
        false
      );
    }
  }
  async getVictimeName(id)
  {
    let promise = await (this.generalService.getDS('avtPerso',id)).toPromise()
    var userName =promise["perso"][0].Perso_Prenom +' '+ promise["perso"][0].Perso_Nom
    //console.log(userName);
    return userName;
  }
  async getEmployeurName(id)
  {
    let promise = await (this.generalService.getDS('SOC',id)).toPromise()
    var socName =promise["SOC"][0].SOC_RS 
    //console.log(socName);
    return socName;
  }

  dateFinChange() {
    this.dateFinF = this.datePipe.transform(this.dateFin, 'MM/dd/YYYY')
  }
  dateDebChange() {
    this.dateDebD = this.datePipe.transform(this.dateDeb, 'MM/dd/YYYY')
  }
}
